// src/routes/courierRoutes.js
import AuthRoute from '../modules/Base/Auth/components/AuthRoute';
import RouteSheets from '../modules/Courier/RouteLists/RouteLists';
import Home from '../modules/Courier/index';
import Route from '../modules/Courier/Route/Route';
import RouteMap from '../modules/Courier/Map/RouteMap';
import ReceiptMap from '../modules/Courier/Map/ReceiptMap';
import ReceiptPage from '../modules/Courier/ReceiptPage/ReceiptPage';




// import CourierStatisticsPage from '../modules/Courier/Courier/CourierStatisticsPage';

const courierRoutes = [

  {path: '/courier',                           element: (<AuthRoute requiredPermissions={['pages:courier:view:any']}><Home /></AuthRoute>),},
  {path: '/courier/routes',                    element: (<AuthRoute requiredPermissions={['pages:courier:view:any']}><RouteSheets /></AuthRoute>),},
  {path: '/courier/routes/:id',                element: (<AuthRoute requiredPermissions={['pages:courier:view:any']}><Route /></AuthRoute>),},
  {path: '/courier/receipts/:receiptNumber',   element: (<AuthRoute requiredPermissions={['pages:courier:view:any']}><ReceiptPage /></AuthRoute>),},
  {path: '/courier/routes/:id/map',            element: (<AuthRoute requiredPermissions={['pages:courier:view:any']}><RouteMap /></AuthRoute>),},
  {path: '/courier/receipts/:id/map',          element: (<AuthRoute requiredPermissions={['pages:courier:view:any']}><ReceiptMap /></AuthRoute>),},
  //{path: '/courier/statistics',              element: (<AuthRoute requiredPermissions={['pages:courier:view:any']}><CourierStatisticsPage /></AuthRoute>),},
  
];

export default courierRoutes;
